import { useState } from "react"

import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { useFetchHomes } from "src/data/organizations/queries/homeQueries"
import { MTooltip } from "src/ui/MTooltip/MTooltip"

export function HomeNamesTooltip({
  homeIds,
  children,
}: {
  homeIds: string[]
  children: React.ReactNode
}) {
  const { orgId } = useOrganization()

  const [isOpen, setIsOpen] = useState(false)

  const fetchHomes = useFetchHomes({
    orgId,
    filters: {
      ids: homeIds,
    },
    options: {
      enabled: isOpen && homeIds.length > 0,
    },
  })

  return (
    <MTooltip
      open={isOpen}
      title={fetchHomes.data?.homes.map((home) => home.name).join(", ")}
    >
      <div
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {children}
      </div>
    </MTooltip>
  )
}
